import NavBar from "frontend/Components/DesignSystem/NavBar";
import HeroAnimation from "frontend/Components/HeroAnimation/HeroAnimation";
import React from "react";
import "../../../../css/Customer/Pages/OurServicesPage/Service.css";
import FAQContainer from "frontend/Components/DesignSystem/FAQ/FAQContainer";
import CardProduct from "frontend/Components/DesignSystem/Cards/CardProduct";
import { ReactComponent as MortagePlanningIcon } from "../../../../assets/icons/Mortgage-Planning.svg";
import { ReactComponent as CorporatePlanningIcon } from "../../../../assets/icons/Corporate-Planning.svg";
import { ReactComponent as InvestmentPlanningIcon } from "../../../../assets/icons/Investment-Planning.svg";
import { ReactComponent as EquityReleaseIcon } from "../../../../assets/icons/Equity -Release.svg";
import { ReactComponent as InsuranceProtectionIcon } from "../../../../assets/icons/Insurance-Protection.svg";
import { ReactComponent as RetirementPlanningIcon } from "../../../../assets/icons/Retirement-Planning.svg";
import AdviserValues from "frontend/Components/AdviserValues/AdviserValue";
import { ReactComponent as NumberOneIcon } from "../../../../assets/icons/Number 1.svg";
import { ReactComponent as NumberTwoIcon } from "../../../../assets/icons/Number 2.svg";
import { ReactComponent as NumberThreeIcon } from "../../../../assets/icons/Number 3.svg";
import { ReactComponent as NumberFourIcon } from "../../../../assets/icons/Number 4.svg";
import Testimonials from "../../../Components/Testimonials/Testimonials";
import { ContactUs } from "frontend/Components/ContactForm/ContactUs";
import Footer from "frontend/Components/DesignSystem/Footer";
// import CustomerRetirementImage from "../../../../../assets/images/customer-retirement-min.jpeg";
import SeoHelmet from "frontend/Components/SEO/SeoHelmet";
import { SEO_PAGES, getPageUrl } from "frontend/Utils/seoConfig";
import ImageDirectory from "frontend/HelperFunctions/ImageDirectory";

/**
 * CorporatePlanning component renders the Corporate Planning service page.
 *
 * This page provides information about corporate planning services, including
 * FAQs, adviser values, and related service cards. It also includes navigation,
 * testimonials, contact information, and a footer.
 *
 * @component
 *
 * @returns {JSX.Element} The rendered Corporate Planning service page.
 *
 * @example
 * // Usage in a React Router route
 * <Route path="/OurServices/CorporatePlanning" element={<CorporatePlanning />} />
 */
const CorporatePlanning = () => {
  const navigationItems = [
    { label: "Home", navigateTo: "/" },
    { label: "Our Services", navigateTo: "/OurServices" },
    { label: "About Us", navigateTo: "/AboutUs" },
    { label: "Contact Us", navigateTo: "/ContactUs" },
  ];
  const faqs = [
    {
      question: "What is corporate planning?",
      answer:
        "We can help the Directors of a Company in a number of ways.  This can include life cover, to ensure that there is sufficient money to buy out another Directors share of a business.	We can also help Directors to make Pension contributions directly from their Companies.   This is tax efficient as it counts as a business expense and can reduce the corporation tax bill.  This is a very tax-efficient way of legally transferring money from a company to a Director, whilst boosting their pension fund for retirement.  ",
    },
  ];
  const values = [
    {
      icon: <NumberOneIcon />,
      text: "You are our most important person",
    },
    {
      icon: <NumberTwoIcon />,
      text: "Recommendations are planned out and delivered to you",
    },
    {
      icon: <NumberThreeIcon />,
      text: "Deliver the best outcomes for you",
    },
    {
      icon: <NumberFourIcon />,
      text: "We talk you through every step of the process",
    },
  ];

  return (
    <div className="Service">
      <SeoHelmet
        page={SEO_PAGES.corporatePlanning}
        service={{
          name: "Corporate Planning",
          description:
            "Rosemount Financial Solutions provides corporate planning support including relevant life cover, key person insurance, executive income protection, shareholder protection and director pension contribution planning.",
          serviceType: [
            "Corporate Planning",
            "Business Protection",
            "Relevant Life Cover",
            "Key Person Insurance",
            "Shareholder Protection",
            "Executive Income Protection",
            "Director Pension Contributions",
            "Company Pension Planning",
          ],
        }}
        breadcrumbs={[
          {
            name: "Home",
            url: getPageUrl("/"),
          },
          {
            name: "Our Services",
            url: getPageUrl("/OurServices"),
          },
          {
            name: "Corporate Planning",
            url: getPageUrl("/OurServices/CorporatePlanning"),
          },
        ]}
        faqs={faqs}
      />
      <NavBar navigationItems={navigationItems} />
      <HeroAnimation
        imgSrc={ImageDirectory["customer-corporate-min"]}
        altText="A meeting room with ten empty seats around the table."
        children={
          <>
            <h1>Corporate Planning</h1>
            <div className="SubTitle">
              Ensuring your business growth and stability
            </div>
          </>
        }
      />
      <div className="SubTitle-Container">
        <div className="SubTitle">
          We are here to ensure your business is protected with a suitable plan
          tailored for you, ensuring everything is in place to help with your
          business needs. Our advisers can discuss relevant life, key person
          insurance, executive income protection and shareholder protection, all
          to ensure your business continues to run smoothly, even when the worst
          happens to you or an employee.
        </div>
        <div className="SubTitle">
          This is with a view on the long-term future of the company to ensure
          you are progressing forward.
        </div>
      </div>
      <FAQContainer faqs={faqs} />
      <div className="Customer-Services-Container">
        <h2>Our Services</h2>
        <div className="Customer-Services">
          <CardProduct
            Icon={MortagePlanningIcon}
            title="Mortgage Planning"
            link="/OurServices/MortgagePlanning"
          />

          <CardProduct
            Icon={InvestmentPlanningIcon}
            title="Investment Planning"
            link="/OurServices/InvestmentPlanning"
          />
          <CardProduct
            Icon={RetirementPlanningIcon}
            title="Retirement Planning"
            link="/OurServices/RetirementPlanning"
          />
          <CardProduct
            Icon={EquityReleaseIcon}
            title="Equity Release"
            link="/OurServices/EquityRelease"
          />
          <CardProduct
            Icon={InsuranceProtectionIcon}
            title="Insurance/ Protection"
            link="/OurServices/InsuranceProtection"
          />
        </div>
      </div>
      <AdviserValues title="Our Adviser Values" values={values} />
      <Testimonials />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default CorporatePlanning;
